import React from "react";
import { Box, Skeleton, TableCell, TableRow, Typography } from "@mui/material";

export default function LisitingSkeleton() {
  return (
    <>
      <TableRow
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
        }}
      >
        <TableCell>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Skeleton
              variant="text"
              sx={{ fontSize: "1.2rem" }}
              width={20}
              height={20}
            />
          </Box>
        </TableCell>
        <TableCell>
          <Typography variant="h4" component="h4" className="E_title">
            <Skeleton variant="text" sx={{ fontSize: "1.1rem" }} width={130} />
          </Typography>
        </TableCell>
        <TableCell>
          <Typography variant="h4" component="h4" className="cus_title">
            <Skeleton variant="text" sx={{ fontSize: "1.1rem" }} width={80} />
          </Typography>
        </TableCell>
        <TableCell>
          <Typography variant="p" component="p" className="mssg">
            <Skeleton variant="text" sx={{ fontSize: "1.1rem" }} width={80} />
          </Typography>
        </TableCell>

        <TableCell>
          <Typography variant="p" component="p" className="mssg">
            <Skeleton variant="text" sx={{ fontSize: "1.1rem" }} width={80} />
          </Typography>
        </TableCell>
        <TableCell>
          <Typography variant="p" component="p" className="mssg">
            <Skeleton variant="text" sx={{ fontSize: "1.1rem" }} width={80} />
          </Typography>
        </TableCell>
      </TableRow>
    </>
  );
}
